import { Routes } from '@angular/router';
import { AttachmentUploader } from './attachment/attachment';

export const routes: Routes = [
  {
    component: AttachmentUploader,
    path: 'attachment',
  },
  {
    path: '**',
    redirectTo: '/attachment',
  },
];
